import React from 'react';

const Navigation = ({ currentPage, setCurrentPage }) => {
  const pages = [
    { id: 'introduction', label: 'Introduction', icon: '📚' },
    { id: 'howto', label: 'How to Use', icon: '📝' },
    { id: 'tool', label: 'Risk Assessment Tool', icon: '🛠️' }
  ];

  return (
    <nav className="bg-white shadow-lg rounded-lg p-4 mb-6">
      <div className="flex justify-center space-x-1">
        {pages.map((page) => (
          <button
            key={page.id}
            onClick={() => setCurrentPage(page.id)}
            className={`px-6 py-3 rounded-lg font-medium transition-colors duration-200 flex items-center space-x-2 ${
              currentPage === page.id
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            }`}
          >
            <span className="text-lg">{page.icon}</span>
            <span>{page.label}</span>
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;